module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"order_id":"Order ID","date_ordered":"Date ordered","billing_address":"Billing address","qty":"Qty","thank_you_for_shopping":"Thank you for shopping with us!"},"id":{"order_id":"Order ID","date_ordered":"Tanggal Order","billing_address":"Alamat tagihan","qty":"Qty","thank_you_for_shopping":"Terima kasih berbelanja dengan kami!"}}')
  delete Component.options._Ctor
}
